import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { useJobCatalogTreeVisibility } from 'modules/job_catalog/hooks/useJobCatalogTreeVisibility'

const NodePage = () => {
  const { canSeeTree } = useJobCatalogTreeVisibility()

  return (
    <AuthorizeUser authorizeFn={() => canSeeTree}>
      <Outlet />
    </AuthorizeUser>
  )
}

export default NodePage
